module.exports = __webpack_public_path__ + "img/no_order_app.f1f62c5.png";